<template>
  <div>
    <div class="site-banner">
      <div class="banner-major">
        <!-- <div
              class="site-image-desktop"
              :style="{
                'background-image':
                  'url(' + currentUrl + '/img/sale_page_single/' + item.section_value.banner_background + ')'
              }"
            ></div>-->
        <div class="container">
          <div class="site-banner-picture">
            <picture>
              <source
                :srcset="currentUrl + '/img/sale_page_single/' + item.section_value.banner_background"
                media="(min-width: 1000px)"
              />
              <source
                :srcset="currentUrl + '/img/sale_page_single/' + item.section_value.banner_background"
                media="(min-width: 320px)"
              />
              <img :src="currentUrl + '/img/sale_page_single/' + item.section_value.banner_background" />
            </picture>
          </div>
          <div class="site-banner-product">
            <div class="site-banner-detail">
              <div class="detail-box-left">
                <h3 v-text="item.section_value.banner_title" />
                <h5 v-text="item.section_value.banner_subtitle" />
              </div>
              <div class="detail-box-right">
                <button
                  @click="BannerDownloadFile(item.sale_page_section_id)"
                  class="btn--download btn--square btn--full"
                >
                  ดาวน์โหลดแผน
                </button>
                <p v-html="item.section_value.banner_text_center" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['currentUrl'])
  },
  methods: {
      BannerDownloadFile(url) {
            window.location = this.currentUrl + '/campaign_salepage_download/' + url
        },
  },
}
</script>

<style lang="scss" scoped>
</style>